<script setup>
import { onMounted, ref } from 'vue'
import { getCurrentInstance } from 'vue'
import BIChatTable from './components/BIChatTable.vue'

const { proxy } = getCurrentInstance()
const token = `Bearer ${proxy.$store.getters.authToken}`

const hoje = new Date().toISOString().slice(0, 10)
const date = ref([hoje, hoje])

const isLoadingList = ref(false)
const chats = ref([])

const handleDateRange = (dateRange) => {
    // Trata a data que chega para o formato correto 
    date.value = [
        String(dateRange[0].toLocaleDateString('pt-BR')).replaceAll('/', '-'),
        String(dateRange[1].toLocaleDateString('pt-BR')).replaceAll('/', '-')
    ]

    getChatsReport()
}

const getChatsReport = async () => {
    isLoadingList.value = true

    try {
        fetch(`/help-queries/support-chats-report?date=${JSON.stringify(date.value)}`, {
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            }
        }).then(async (response) => {
            const data = await response.json()

            chats.value = data.chats
        })

    } catch (error) {
        console.error('Erro ao carregar os dados do relatório de chats de suporte:', error)
    } finally {
        isLoadingList.value = false
    }
}

onMounted(() => {
    getChatsReport()
})
</script>


<template>
    <div ref="tools" id="tools" class="border border-solid border-grey-light rounded overflow-hidden ps-container email-scroll-area ps ps--theme_default">
        <!-- Tela inicial do relatório de chats de suporte -->
        <div class="p-6 flex">
            <h1 class="text-2xl font-bold mb-4  mx-auto block">Relatório de chats</h1>

            <!-- Botão de voltar -->
            <router-link :to="'/help-queries'" >
                <vs-button
                    class="align-center center w-6 h-6"
                    color="primary"
                    icon="arrow_left"
                >
                </vs-button>
            </router-link>
        </div>

        <div class="p-6">
            <BIChatTable
                @update:dateRange="handleDateRange" 
                :data="chats"
                :loading="isLoadingList"
            />
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/vuesax/apps/email.scss";
</style>

<style>
    #tools {
        height: 100%;

        background-color: #fff;
    }
</style>
